export default "__VITE_ASSET__DPRJm5Qo__"